(function () {
    'use strict';

    function GeneralScheduleController($scope, $state, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $timeout, DialogService, CompanyInfoQuery) {

        var $ctrl = this;
        $ctrl.loadPage = loadPage;


        $timeout(function () {

            loadPage();

        });


        function loadPage(page) {
            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            $ctrl.scheduleInfos = [];


        }


    }

    var GeneralSchedule = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/general-schedule/partial-form.general-schedules.html',
        controller: GeneralScheduleController,
        bindings: {

            scheduleInfo: '='
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfGeneralSchedule', GeneralSchedule)

    //  GeneralScheduleController.$inject = ['$scope','$attrs','$element'];
    GeneralScheduleController.$inject = ['$scope', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$timeout', 'DialogService', 'CompanyInfoQuery'];


})();

